import { useState } from 'react'
import MarketingNav from './MarketingNav'
import MarketingFooter from './MarketingFooter'
import SupportWidget from './SupportWidget'
import '../AppLandingPage.css'

/**
 * Shared shell for marketing pages: navbar on top, footer + support chat
 * widget underneath the page content. Children render in between.
 */
export default function MarketingLayout({ children }) {
    const [supportOpen, setSupportOpen] = useState(false)

    const openSupport = () => setSupportOpen(true)

    return (
        <div className="app-landing-root">
            <MarketingNav onSupportClick={openSupport} />
            {children}
            <SupportWidget open={supportOpen} setOpen={setSupportOpen} />
            <div className="footer-divider" />
            <MarketingFooter onSupportClick={openSupport} />
        </div>
    )
}
